import {Component, Inject, OnDestroy,} from "@angular/core";
import {TemperatureSensorModel} from "../../models/temperature-sensor-model";
import {formatNumber} from "@angular/common";
import {PumpSensorModel} from "../../models/pump-sensor-model";
import {IImmoConnDataOneWireItem,} from "../../interfaces/iotMaxxGateway.response";
import {MqttBlockingService} from '../../services/mqtt-blocking.service';
import {Subscription} from 'rxjs';
import {AutoSaveService} from '../../services/auto-save.service';
import {GatewayType, IDeviceData} from "../../interfaces/juconnGateway.response";
import {DeviceDataService} from "../../services/device-data.service";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {Utils} from "../../utils/utils";

@Component({
  selector: "app-raw-data-modal",
  templateUrl: "./raw-data-modal.component.html",
  styleUrls: ["./raw-data-modal.component.scss"],
})
export class RawDataModalComponent implements OnDestroy {
  public gatewayId: string;
  public isLoading = false;
  public hasError = false;

  public refreshButtonClicked = false;
  public gatewayRawData: IDeviceData;
  public temperatureSensors: { number: number, id: string, value: string }[];
  public currentLoops: { number: number, id: string, value: string }[];
  public modules: { number: number, id: string, value: string }[];

  private mqttBlockingSub: Subscription;
  private deviceDataSub: Subscription;
  public isMqttBlocked = false;

  constructor(
    private dialogRef: DialogRef<void>,
    @Inject(DIALOG_DATA) private data: {
      gatewayId: string;
    },
    private mqttBlockingService: MqttBlockingService,
    private autoSaveService: AutoSaveService,
    private deviceDataService: DeviceDataService
  ) {
    this.gatewayId = this.data.gatewayId;

    this.mqttBlockingSub = this.mqttBlockingService.getBlockedGateways().subscribe((gateways) => {
      if (this.gatewayId) {
        this.isMqttBlocked = gateways.includes(this.gatewayId);
      }
    });

    this.deviceDataSub = this.deviceDataService.deviceData$.subscribe((data) => {
      if (data) {
        this.setDeviceData(data.deviceData);
        this.isLoading = data.isLoading;
        this.hasError = data.hasError;
      }
    });
  }

  ngOnDestroy(): void {
    this.mqttBlockingSub.unsubscribe();
  }

  closeModal() {
    this.dialogRef.close();
  }

  getPumpSensorValue(sensor: PumpSensorModel) {
    if (Number.isFinite(sensor.value)) {
      return formatNumber(sensor.value, "de_DE");
    } else {
      return "-";
    }
  }

  getCounterSensorValue(sensor: TemperatureSensorModel) {
    if (Number.isFinite(sensor.value)) {
      return formatNumber(sensor.value, "de_DE") + "m³";
    } else {
      return "-";
    }
  }

  getTemperatureSensorValue(sensor: IImmoConnDataOneWireItem) {
    if (Number.isFinite(sensor.temperature.value)) {
      return formatNumber(sensor.temperature.value, "de_DE") + " °C";
    } else {
      return "-";
    }
  }

  async onGatewayRefreshBtnClicked() {
    if (this.isMqttBlocked) {
      return;
    }

    this.refreshButtonClicked = true;

    await this.deviceDataService.reloadDeviceData();
    Utils.initPumpSensorIds(this.deviceDataService.getDeviceData().deviceData);
  }

  public getStateValue(x: number): string {
    switch (x) {
      case 0:
        return 'Aus';
      case 1:
        return 'An';
      case -1:
        return 'Fehler';
      default:
        return '-';
    }
  }

  private setDeviceData(rawData: IDeviceData) {
    this.gatewayRawData = rawData;
    const temperatureSensors: { number: number, id: string, value: string }[] = [];
    const currentLoops: { number: number, id: string, value: string }[] = [];
    const modules: { number: number, id: string, value: string }[] = [];

    if (this.gatewayRawData) {

      console.log(this.gatewayRawData);

      let tempNumber = 1;
      let loopNumber = 1;

      for (let i = 0; i < this.gatewayRawData.uvsModule.length; i++) {
        const module = this.gatewayRawData.uvsModule[i];
        if (module.moduleInfo.uvsType === GatewayType.HSC) {
          continue;
        }
        if (module.w1?.length > 0) {
          module.w1.sort((a, b) => +a.name - +b.name);
          for (const sensor of module.w1) {
            temperatureSensors.push({
              number: tempNumber,
              id: module.moduleInfo.address + '.' + sensor.name,
              value: this.getTemperatureSensorValue(sensor),
            });
            tempNumber++;
          }
        }
        if (module.currentLoop?.length > 0) {
          let index = 1;
          for (const sensor of module.currentLoop) {
            currentLoops.push({
              number: loopNumber,
              id: module.moduleInfo.address + '.' + index,
              value: sensor.toString(),
            });
            loopNumber++;
            index++;
          }
        }
        let moduleId;
        switch (module.moduleInfo.uvsType) {
          case GatewayType.SM01:
            moduleId = ' Sensormodul';
            break;
          case GatewayType.SM02:
            moduleId = ' Zählermodul SM02';
            break;
          case GatewayType.SM03:
            moduleId = ' Zählermodul SM03';
            break;
          case GatewayType.SM04:
            moduleId = ' Zählermodul SM04';
            break;
          case GatewayType.SM05:
            moduleId = ' Zählermodul SM05';
            break;
          case GatewayType.OTM01:
            moduleId = ' Außentemperaturmodul 1';
            break;
          case GatewayType.OTM02:
            moduleId = ' Außentemperaturmodul 2';
            break;
          case GatewayType.OTM03:
            moduleId = ' Außentemperaturmodul 3';
            break;
          default:
            moduleId = ' Unbekanntes Modul';
            break;
        }
        modules.push({
          number: i + 1,
          id: module.moduleInfo.address + moduleId,
          value: 'FW Version ' + module.moduleInfo.fwVersion,
        })
      }
    }
    this.temperatureSensors = temperatureSensors;
    this.currentLoops = currentLoops;
    this.modules = modules;
  }
}
